<template>
    <div  class="meeting_des">
        <div v-html="meetingDes"></div>
    </div>
</template>
<script>

export default ({
    props:['meetingDes']
})
</script>
<style scoped lang="scss">
.meeting_des {
  /deep/ img {
    max-width: 100% !important;
    width: auto !important;
    height: auto !important;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Meeting/Introduction.vue